import React from 'react';
import {_GPY,__GPYPost} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardAdvertisementTournament extends  React.Component {

	constructor(props) {
		super(props);
		this.state = {
			tournamentsIsLoaded: false,
			tournaments: {},
			advertisementsIsLoaded : false,
			advertisements : {},
	 	};
	}

	componentDidMount() {
		this.getAdvertisements();
		this.getTournaments();
	}

	getAdvertisements() {
		__GPYPost('getAdvertisements',{usageType:"ADVERTISING"},(res)=>{
			this.setState({
				advertisementsIsLoaded: true,
				advertisements: res,
			});
		},(err)=>{
			this.setState({
				advertisementsIsLoaded: false,
			});
		});
	}

  fillTournamentData(tournament,games) {
	      var g = this.getGameMapByTournament(tournament,games);
	      console.log("GAMES",g);
	      var res = {};
	      tournament._data.games.forEach((p, i) => {
	          p.forEach((v, c) => {
	              if(v>0) {
	                  res[ i+"-"+c ] = g[v];
	                  delete res[ i+"-"+c ].crews;
	                  delete res[ i+"-"+c ].players;
	                  delete res[ i+"-"+c ].referees;
	              } else {
	                   res[ i+"-"+c ] = {id:-1};
	              }
	                console.log("REPLACE",v);
	          });
	      });

	      return res;
	}

	getTournaments(obj) {
        if(obj === undefined) {
          obj = {};
        }
        __GPYPost('getTournaments',obj,(res) => {

           res.Tournaments.Tournament.forEach((t, i) => {
               t._data = JSON.parse(t.data);
           });

           this.setState({
            tournamentsIsLoaded: true,
            tournaments: res,
           });
        },(err)=>{
        });
    }


  render () {
    return (
			<>
				<div className="row">
							<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_advertisement_title')}</strong></div>
							 {this.state.advertisementsIsLoaded ? this.state.advertisements.Advertisements.Advertisement.map((t) =>
								 <div key={t.id} className="col-4 p-1">
								 <GpyToggleButton key={t.id} title={t.name} onInit={() => {return {}}}
										 onDeactivate={() => {return {visible: false,text:""}}}
										 onActivate={() => {return {visible: true,advertisement:t}}}
										 scoreboard={this.props.scoreboard}
										 getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
										 stateName={this.props.scoreboard.getName()+"_button_advertisement_"+t.id}/>
								 </div>
							 ) : "" }
        </div>

		{_GPY.uiStates.userLvl >= _GPY.USER_EXPERT ?

				<div className="row">
					 <div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_tournament_title')}</strong></div>

							 {this.state.tournamentsIsLoaded ? this.state.tournaments.Tournaments.Tournament.map((t) =>
								 <div key={t.id} className="col-4 p-1">
								 <GpyToggleButton key={t.id} title={t.name} onInit={() => {return {}}}
										 onDeactivate={() => {return {visible: false,text:""}}}
										 onActivate={() => { console.log(this.fillTournamentData(t,this.state.games.Games.Game)); return {visible: true,
											 tournament:this.fillTournamentData(t,this.state.games.Games.Game),
										 }}}
										 scoreboard={this.props.scoreboard}
										 getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
										 stateName={this.props.scoreboard.getName()+"_tournament_"+t._data.teamCount+"_"+t.id}/>
								 </div>
							 ) :  "" }
				</div>
				
		 :""}

		 </>
		);
  }

}
export default ScoreboardAdvertisementTournament;
